interface ISignature {
  sigId: number;
  sigName: string;
  description?: string;
  selection: string;
  selectionRule?: string;
  selectionGroup: string;
  insertInto: string;
  sigPlacement: string;
  configurationType: string;
  convertPlainToHtml: string;
  usePlainTextFile: string;
  signature: string;
  image?: string;
  imgID?: string;
  plainTextSignature?: string;
  Priority?: number;
  sLinksjText?: string;
  headerCode?: string;
  modifierName?: string;
  imageList: string[];
  imgIdList: string[];
  dynamicGroup: string;
}

export class Signature implements ISignature {
  sigId: number;
  sigName: string;
  description?: string;
  selection: string;
  selectionRule?: string;
  selectionGroup: string;
  insertInto: string;
  sigPlacement: string;
  configurationType: string;
  convertPlainToHtml: string;
  usePlainTextFile: string;
  signature: string;
  image?: string;
  imgID?: string;
  plainTextSignature?: string;
  priority?: number;
  sLinksjText?: string;
  headerCode?: string;
  modifierName?: string;
  isBookmarked?: boolean;
  imageList: string[];
  imgIdList: string[];
  dynamicGroup: string;
}

export enum CoercionType {
  text = 'text',
  html = 'html',
}

export class UserEmailInformation {
  bodyType: CoercionType;
  to: string[];
  from: string;
  subject: string;
  body: string;
  baseURL: string;
  date: string;
  isReplyEmail: string;
  sigid: number;
  displayName: string;
  isEditMode: boolean;
  signatureInsert: string;
  signatureBlocks: string;
  signatureHTML: string;
  signatureSigPlacement: string;
}

export class SigBlockPayload {
  sigData: Signature;
}

export interface SignatureImageItem {
  imageCID: string;
  imageData: string;
}

export interface SignatureListItemResponse {
  id?: number;
  signature?: string;
  configurationName?: string;
  images?: SignatureImageItem[];
}

export interface SignaturesStatusResponse {
  isOK?: boolean;
  signatures?: SignatureListItemResponse[];
  status?: string;
}

export interface OrgDataRequest {
  tenantName: string;
  customerID: string;
}

export interface UserEmailInformationRequest {
  BaseURL: string | null;
  Body: string | null;
  BodyType: any;
  Date: Date;
  From: any;
  IsReplyEmail: boolean;
  Subject: string;
  To: string[];
  Sender: string;
  Upn: string;
  UseUpnForFrom: boolean;
  DefaultSignatureId?: any;
  orgData?: OrgDataRequest;
  CheckFF: boolean;
}

export interface GetDefaultSignatureRequestBody {
  userEmailInformation: UserEmailInformationRequest;
  selectable: boolean;
  getAutoDefaultType: any;
}

export enum LOCALSIGNATURE_STATUS {
  STATUS_SIGANTUREADDED,
  STATUS_LISTGENERATED,
  STATUS_NOSIGANTURE,
  STATUS_EMPTYTOKEN,
  STATUS_NOTAUTHORISED,
  STATUS_INVALIDTOKEN,
  STATUS_UNKNOWN,
  STATUS_ERROR,
}

